import { StatusBar, Style } from "@capacitor/status-bar";
import { Capacitor } from "@capacitor/core";
import { useAtom } from "jotai";
import { highContrastAtom } from "../jotai/atoms";

export default function NativeStatusBar() {
  const [highContrast] = useAtom(highContrastAtom);
  if (Capacitor.isNativePlatform()) {
    StatusBar.setOverlaysWebView({ overlay: false });
    StatusBar.setStyle({
      style: Style.Dark,
    });
    /**
     * Sadly, we don't have access to the DaisyUI theme. These values are manually hardcoded and should be kept up to
     * date with the color-secondary variables in the  DaisyUI theme.
     */
    let color = highContrast ? "#0068ab" : "#009DDD";
    StatusBar.setBackgroundColor({ color });
    /**
     * This will put the webview over the status bar wherever its supported. In conjunction with things like
     * pt-[env(safe-area-inset-top)], this lets us get easy bg color support in the status bar in (at least) iOS.
     */
    StatusBar.setOverlaysWebView({ overlay: true });
  }

  return null;
}
